<template>
    <div>
      <!--数据更新-->
      <el-card style="height: auto; margin-top: 10px;">
        <div slot="header" class="clearfix">
          <span>数据更新</span>
        </div>
        <el-tabs v-model="UdpSend.params.cmd" type="card">
          <el-tab-pane label="设置更新时间间隔" name="0x83">
            <el-form v-show="UdpSend.params.cmd === '0x83'" label-width="80px" :model="UdpSend.params" :ref="UdpSend.params" >
              <el-form-item label="设备" prop="devID">
                <!--<el-input v-model="UdpSend.params.devID" style="width: 100%"></el-input>-->
                <el-select v-model="UdpSend.params.devID" filterable>
                  <el-option v-for="item in alarmPointList" :label="item.pointName" :value="item.devID"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="更新间隔" prop="interval">
                <el-input-number v-model="UdpSend.params.interval" :min="30" :max="3600" label="秒" oninput="value=value.replace(/[^\d.]/, '')"></el-input-number>
                <span style="color: red; position: relative; margin-left: 30px;"> * 单位：秒，范围：30-3600</span>
              </el-form-item>
              <el-form-item >
                <el-button type="primary" @click="udpSend83">确定</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="读取终端配置信息" name="0x84">
            <div style="margin-left: 50px">设备:
              <el-select v-model="UdpSend84.params.devID" filterable>
                <el-option v-for="item in alarmPointList" :label="item.pointName" :value="item.devID"></el-option>
              </el-select>
            </div>
            <div style="margin-left: 100px;margin-top: 20px"><el-button type="primary" @click="udpSend84">查询</el-button></div>
          </el-tab-pane>
          <el-tab-pane label="修改地址码">
            <div style="margin-left:30px">设备:
              <el-select v-model="UdpSend86.params.devID" filterable>
                <el-option v-for="item in alarmPointList" :label="item.pointName+item.devID" :value="item.devID"></el-option>
              </el-select>
            </div>
            <div style="margin-top:20px;margin-left:30px">
              新地址码:<el-input v-model="UdpSend86.params.devIDNew" style="width:200px"></el-input>
            </div>
            <div style="margin-top:20px;margin-left:30px">
              <el-button type="primary" @click="udpSend86">确认修改</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="查看发送日志信息">
            <div>
              <el-button type="primary" @click="logOfSend">刷新</el-button>
            </div>
            <div>
              <el-table :data="logList">
                <el-table-column
                  prop="devID"
                  label="设备编号"
                ></el-table-column>
                <el-table-column
                  prop="cmd"
                  label="命令码"
                ></el-table-column>
                <el-table-column
                  prop="id"
                  label="命令ID"
                ></el-table-column>
                <el-table-column
                prop="devIDNew"
                label="新设备ID"
              ></el-table-column>
                <el-table-column
                  prop="creatTime"
                  label="发送命令时间"
                ></el-table-column>
                <el-table-column
                  prop="code"
                  label="应答状态"
                ></el-table-column>
                <el-table-column
                  prop="conf"
                  label="应答值"
                ></el-table-column>
                <el-table-column
                prop="answerTime"
                label="应答时间"
                ></el-table-column>
                </el-table>
            </div>
            <div style="float: right">
              <el-pagination
                @current-change="logOfSend"
                background
                layout="prev, pager, next"
                :page-size="10"
                :total="logTotalPage*10"
                :current-page.sync="sendLog.params.pageNumber">
              </el-pagination>
            </div>
          </el-tab-pane>
<!--          <el-tab-pane label="设置字段是否显示" name="0x84">-->
<!--            <el-form v-show="UdpSend.params.cmd === '0x84'" label-width="80px">-->
<!--              <el-form-item label="设备" prop="devID">-->
<!--                &lt;!&ndash;<el-input v-model="UdpSend.params.devID" style="width: 100%"></el-input>&ndash;&gt;-->
<!--                <el-select v-model="UdpSend.params.devID" >-->
<!--                  <el-option v-for="item in alarmPointList.result.alarmPointList" :label="item.pointName" :value="item.devID"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="  ">-->
<!--                <el-switch v-model="UdpSend.params.indoorTH" active-text="显示室内温湿度"></el-switch>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                <el-switch v-model="UdpSend.params.gas" active-text="有害气体浓度"></el-switch>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                <el-switch v-model="UdpSend.params.outdoorTH" active-text="室外温湿度"></el-switch>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                <el-switch v-model="UdpSend.params.sound" active-text="室外环境声"></el-switch>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                <el-switch v-model="UdpSend.params.PM" active-text="颗粒物浓度"></el-switch>-->
<!--              </el-form-item>-->
<!--              <el-form-item >-->
<!--                <el-button type="primary" @click="udpSend">确定</el-button>-->
<!--              </el-form-item>-->
<!--            </el-form>-->
<!--          </el-tab-pane>-->


<!--          <el-tab-pane label="手动更新数据" name="0x85">-->
<!--            <el-form v-show="UdpSend.params.cmd === '0x85'" label-width="80px">-->
<!--              <el-form-item label="设备" prop="devID">-->
<!--                &lt;!&ndash;<el-input v-model="UdpSend.params.devID" style="width: 100%"></el-input>&ndash;&gt;-->
<!--                <el-select v-model="UdpSend.params.devID" >-->
<!--                  <el-option v-for="item in alarmPointList.result.alarmPointList" :label="item.pointName" :value="item.devID"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                <el-button type="primary" @click="udpSend">更新</el-button>-->
<!--              </el-form-item>-->
<!--            </el-form>-->
<!--          </el-tab-pane>-->
        </el-tabs>
        <!--<el-form label-width="80px">-->
          <!--<el-form-item label="设置选项" >-->
            <!--<el-select v-model="UdpSend.params.cmd">-->
              <!--<el-option value="0x83" label="设置更新时间间隔"></el-option>-->
              <!--<el-option value="0x84" label="设置字段是否显示"></el-option>-->
              <!--<el-option value="0x85" label="手动更新数据"></el-option>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
        <!--</el-form>-->
      </el-card>
    </div>
</template>

<script>
  export default {
    name: 'DataUpdate',
    data() {
      return {
        labelPosition: 'left',
        logTotalPage:"",
        UdpSend:{
          "version": 1,
          "method": "tcp.TcpSend",
          "params": {
            "devID": "",
            "cmd": "0x83",
            "id":"0x00",
            "interval":"",	//cmd 为“0x83”时
            "devIDNew":"",//cmd 为 “0x86”时
          },
          "token": "#",
          "id": 0
        },
        UdpSend84:{
          "version": 1,
          "method": "tcp.TcpSend",
          "params": {
            "devID": "",
            "cmd": "0x84",
            "id":"0x00",
          },
          "token": "#",
          "id": 0
        },
        UdpSend86:{
          "version": 1,
          "method": "tcp.TcpSend",
          "params": {
            "devID": "",
            "cmd": "0x86",
            "id":"0x00",
            "devIDNew":""
          },
          "token": "#",
          "id": 0
        },
        sendLog:{
          "version": 1,
          "method": "tcp.GetTcpSendInfo",
          "params": {
		        "pageNumber":"1",
            "cmd":null,
            "answer":null,
            },
          "token": "#",
          "id": 0
        },
        logList:[],
        autoUpdate:true,
        updateInterval:'',
        isUpdating:false,
        // 获取警报点列表
        GetAlarmPointList:{
          "version": 1,
          "method": "alarmpoint.GetPointNameList",
          "params": {
            "pointName":null,
            "alarmPointType":null,
            "areaId":null
          },
          "token": "#",
          "id": 0
        },
        // 警报点列表
        alarmPointList:{
          "version": 1,
          "result":{
            "alarmPointList": [
              {
                "alarmPointId":  "",
                "pointName": "",
                "alarmPointType": "",
                "longitude": "",
                "latitude": "",
                "alarmRadius":"",
                "areaId":"",
                "installAt":"",
                "remark":""
              },
            ]
          },
          "id": 0
        },
      }
    },
    methods:{
      udpSend83(){
        this.$axios.post(this.$mainUrl,this.UdpSend).then(res=>{
          if(res.data.hasOwnProperty('result')){
            alert("指令下发成功")
          }
        })
      },
      udpSend84(){
        this.UdpSend84.params.cmd = "0x84";
        this.UdpSend84.params.id = "0x00"
        this.UdpSend84.params.interval = "";
        this.UdpSend84.params.devIDNew = null;
        for(let key in this.UdpSend84.params){
          if(this.UdpSend84.params[key] === ""){
            this.UdpSend84.params[key] = null;
          }
        }
        this.$axios.post(this.$mainUrl,this.UdpSend84).then(res=>{
          if(res.data.hasOwnProperty('result')){
            alert("信息读取成功，前往日志页面查看")
          }
        })
      },
      udpSend86(){
        this.$axios.post(this.$mainUrl,this.UdpSend86).then(res=>{
          if(res.data.hasOwnProperty('result')){
            alert("修改成功！")
          }
        })
      },
      logOfSend(){
        this.$axios.post(this.$mainUrl,this.sendLog).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.logTotalPage = res.data.result.page;
            this.logList = res.data.result.tcpSendInfo;

          }
        })
      },
      // udpSend(){
      //   if(this.UdpSend.params.cmd !== "0x84"){
      //     this.UdpSend.params.PM = null;
      //     this.UdpSend.params.sound = null;
      //     this.UdpSend.params.outdoorTH = null;
      //     this.UdpSend.params.gas = null;
      //     this.UdpSend.params.indoorTH = null;
      //   }
      //   if(this.UdpSend.params.cmd !== "0x83"){
      //     console.log('不是0x83');
      //     this.UdpSend.params.interval = null;
      //   }
      //   if(this.UdpSend.params.cmd === "0x84"){
      //
      //   }
      //
      //
      //   this.UdpSend.token = this.$store.state.token;
      //   console.log('udpSend请求');
      //   console.log(this.UdpSend);
      //   this.$axios.post(this.$mainUrl, this.UdpSend).then(res=> {
      //     if(this.UdpSend.params.cmd === "0x84"){
      //       console.log('是0x84啊');
      //       this.UdpSend.params.PM = false;
      //       this.UdpSend.params.sound = false;
      //       this.UdpSend.params.outdoorTH = false;
      //       this.UdpSend.params.gas = false;
      //       this.UdpSend.params.indoorTH = false;
      //     }
      //
      //     console.log('udpSend请求得到响应');
      //     console.log(res.data);
      //     if(res.data.hasOwnProperty('result')){
      //       this.$message({
      //         type: 'success',
      //         message: '数据更新成功'
      //       })
      //       this.feedBack();
      //     }else{
      //       this.$message({
      //         type: 'error',
      //         message: '数据更新失败，' + res.data.error.message
      //       })
      //     }
      //   })
      // },
      // 获取警报点列表
      getAlarmPointList(){
        for (let val in this.GetAlarmPointList.params){
          if(this.GetAlarmPointList.params[val] === ""){
            this.GetAlarmPointList.params[val] = null;
          }
        }
        if(this.GetAlarmPointList.params.areaId !== null){
          this.GetAlarmPointList.params.areaId = this.GetAlarmPointList.params.areaId[this.GetAlarmPointList.params.areaId.length-1];
        }
        this.GetAlarmPointList.token = this.$store.state.token;
        console.log('获取警报点列表请求');
        console.log(this.GetAlarmPointList);
        this.$axios.post(this.$mainUrl, this.GetAlarmPointList).then(res=>{
          console.log('获取警报点列表请求得到响应');
          console.log(res.data);
          this.alarmPointList = res.data.result.pointNameList;
        })
      },

    },
    mounted(){
      this.getAlarmPointList();
      this.logOfSend();
    }
  }
</script>

<style scoped>

</style>
